import { I18n } from '../../ol-pdf-printer';

export const en: I18n = {
    printPdf: 'Print PDF',
    pleaseWait: 'Please wait...',
    downloadFinished: 'Download finished, processing...',
    downloadingImages: 'Downloading images',
    error: 'An error occurred while printing',
    errorImage: 'An error ocurred while loading an image',
    printing: 'Exporting',
    cancel: 'Cancel',
    close: 'Close',
    print: 'Export',
    mapElements: 'Map elements',
    extraInfo: 'Extra information',
    url: 'URL',
    date: 'Date',
    specs: 'Specifications',
    compass: 'Compass',
    scale: 'Scale',
    legends: 'Legends',
    layersAttributions: 'Layer attributions',
    addNote: 'Add note (optional)',
    resolution: 'Resolution',
    orientation: 'Orientation',
    paperSize: 'Paper size',
    landscape: 'Landscape',
    portrait: 'Portrait',
    current: 'Current',
    paper: 'Paper',
    printerMargins: 'Add printer margins',
    escapeHint: 'Press here or Escape to cancel',
    reframeHint: 'Adjust the region of interest panning and zooming',
    process: 'Process'
};
